import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import locize from "i18next-locize-backend";
// @ts-ignore
export var options = {
    fallbackLng: "en",
    load: "languageOnly",
    // The full list of namespaces is: 'shared', 'line', 'device', 'stop', 'batches', 'iam', 'alarms', 'stats', 'oee', 'units'
    ns: [
        "fallback",
        "shared"
    ],
    // We use fallback as the default unqualified namespace, to avoid the fallback keys to mess up
    // with the actual keys in the other namespaces.
    defaultNS: "fallback",
    saveMissing: "production" === "development",
    detection: {
        order: [
            "cookie",
            "header",
            "querystring"
        ],
        caches: [
            "cookie"
        ],
        cookieMinutes: 60 * 24 * 365
    },
    react: {
        // NOTE: We cannot use Suspense in SSR
        useSuspense: false
    },
    // NOTE: This option is a bit confusing - it delays initialization until next
    // iteration in the event loop if enabled. We render in the same iteration, so
    // we don't wish to delay initialization.
    initImmediate: false,
    backend: {
        apiKey: "production" === "production" ? undefined : process.env.LOCIZE_API_KEY,
        projectId: process.env.LOCIZE_PROJECT_ID,
        version: "latest"
    }
};
export var initI18n = function(opts) {
    var ref = opts || {}, _ssrLanguage = ref.ssrLanguage, ssrLanguage = _ssrLanguage === void 0 ? "en-GB" : _ssrLanguage, _namespaces = ref.namespaces, namespaces = _namespaces === void 0 ? [
        "shared"
    ] : _namespaces;
    if (i18next.isInitialized) {
        if ("object" !== "undefined") {
            return i18next;
        }
        if (i18next.language !== ssrLanguage) {
            i18next.changeLanguage(ssrLanguage);
        }
        return i18next;
    }
    i18next.use(locize);
    if ("object" !== "undefined") {
        i18next.use(new LanguageDetector());
    }
    i18next.init(Object.assign(Object.assign({}, options), {
        ns: namespaces,
        lng: "object" === "undefined" ? ssrLanguage : undefined,
        interpolation: {
            escapeValue: false,
            formatSeparator: ",",
            format: function(value, format, lng) {
                if (format === "uppercase") {
                    return value.toUpperCase();
                }
                return value;
            }
        }
    })).then(function() {
        if (!i18next.language) {
            i18next.changeLanguage("en-GB");
        }
    });
    return i18next;
};
